module.exports = __webpack_public_path__ + "img/icon_touxiang_two@3x.41351aef.png";